import AxiosClient from './axios-client'

class DashboardService {
  getDados(filtroDeBuscaPadrao) {
    return AxiosClient.post(`Dashboard/getDashboard`, filtroDeBuscaPadrao)
  }

  async getDashboardProfissional(filtros, numeroPagina = 1, registrosPorPagina = 20) {
    try {
      const { data } = await AxiosClient.post(`Dashboard/getDashboardProfissional`, {
        filtros,
        numeroPagina,
        registrosPorPagina,
      })
      return data
    } catch (error) {
      console.log(error)
    }
    return []
  }

  async getDashboardColaborador(filtros) {
    try {
      const { data } = await AxiosClient.post(`Dashboard/getDashboardColaborador`, {
        filtros,
      })
      return data
    } catch (error) {
      console.log(error)
    }
    return {
      data: [],
      totalContratosEfetivados: 0,
      totalProcedimentos: 0,
      totalValorEfetivacao: 0,
      totalProducao: 0,
      totalComissaoProducao: 0,
      totalComissaoEfetivacao: 0,
      totalComissao: 0,
      percentualProducao: 0,
      percentualEfetivacao: 0,
      podeFiltrarColaborador: false,
      podeVerComissao: false,
    }
  }

  transferirResponsavel({ planoId, tipoPlano, novoColaboradorId }) {
    return AxiosClient.post(`Dashboard/transferirResponsavel`, {
      planoId,
      tipoPlano,
      novoColaboradorId,
    })
  }

  async contarPlanosResponsavel(colaboradorOrigemId) {
    const { data } = await AxiosClient.get(`Dashboard/contarPlanosResponsavel/${colaboradorOrigemId}`)
    return data
  }

  async transferirResponsavelEmMassa({ colaboradorOrigemId, colaboradorDestinoId }) {
    const { data } = await AxiosClient.post(`Dashboard/transferirResponsavelEmMassa`, {
      colaboradorOrigemId,
      colaboradorDestinoId,
    })
    return data
  }

  async getDashboard(filtros) {
    try {
      const { data } = await AxiosClient.post(`Dashboard/getNewDashboard`, {
        filtros
      })

      return data
    } catch (error) {
      console.log(error)
    }

    return {
      metric: {
        faturamento: {
          maiorFaturamento: 0,
          faturamentoAtual: 0
        },
      },
      agendamentoClinicoGeralPorPaciente: {
        agendamentos: [],
        presenca: [],
        semReagendar: [],
        faltosos: [],
        totalDeAgendamentos: 0,
        porcentagemPresenca: 0,
        porcentagemSemReagendar: 0,
        porcentagemFaltosos: 0
      }
    }
  }
}

export default new DashboardService()
